module.exports = __webpack_public_path__ + "public/img/down.12025e80.png";